/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSessionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {GetSessionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const getSession = (request: GetSessionRequest, options?: CashRequestOptions) => post<GetSessionRequest, GetSessionResponse>("/2.0/cash/get-session", request, {...options, rejectOnError: true })